import { useState } from "react";
import axios from "axios";

const useFilePost = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const postFile = async (formData) => {
    const token = JSON.parse(sessionStorage.getItem("userData"));
    const access_token = token ? token.access_token : null;
    setError(null);
    try {
      setLoading(true);
      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setData(response?.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, postFile };
};

export default useFilePost;
